import { CheckboxIndicator } from "#components/v2/Checkbox";
import {
  MultiDropdownBase,
  MultiDropdownItemLabel,
  type MultiDropdownOption,
  type MultiDropdownProps,
} from "#components/v2/shared/MultiDropdownBase";

export type MultiSelectDropdownOption = MultiDropdownOption;

export type MultiSelectDropdownProps = MultiDropdownProps;

export function MultiSelectDropdown(props: MultiSelectDropdownProps) {
  return (
    <MultiDropdownBase
      {...props}
      renderItem={(item, isSelected, isHovered, isFocused) => (
        <>
          <CheckboxIndicator isFocused={isFocused} isHovered={isHovered} isSelected={isSelected} />
          <MultiDropdownItemLabel item={item} />
        </>
      )}
    />
  );
}
